import { getDefaultState } from ".";

export default {
  SET_TOKEN_DATA(state, token) {
    localStorage.setItem("token", JSON.stringify(token));
    state.token = token;

    const base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      Buffer.from(base64, "base64")
        .toString()
        .split("")
        .map((c) => {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    state.accountDetails = JSON.parse(jsonPayload);
  },

  LOGOUT(state) {
    Object.assign(state, getDefaultState());
    localStorage.removeItem("currentFarm");
    localStorage.removeItem("token");
  },

  SET_STATUS(state, status) {
    state.status = status;
  },

  SET_FARMS_DATA(state, data) {
    state.farms = data;
    for (const farm of Object.values(state.farms)) {
      farm.schedules = {};
      farm.regions = {};
      farm.terrains = {};
    }
  },

  SET_FARM_DATA(state, { id, farm }) {
    state.farms[id].endusers = farm;
  },

  SET_ACTIVE_SCHEDULE(state, { farmId, scheduleId, scheduleDirty }) {
    state.farms[farmId].schedule_id = scheduleId;
    state.farms[farmId].schedule_dirty = scheduleDirty;
  },

  SET_ENDUSER_UNIT_DATA(state, { farm_id, enduser_id, enduser_units }) {
    state.farms[farm_id].endusers[enduser_id].units = enduser_units;
  },

  SET_ENDUSER_STATS(state, { farmId, enduserId, stats }) {
    state.farms[farmId].endusers[enduserId].stats = stats;
  },

  SET_ENDUSER_SCHEDULE_STATE(
    state,
    { farmId, enduserId, rimScheduleId, enable }
  ) {
    state.farms[farmId].endusers[enduserId].schedule_rim_id = rimScheduleId;
    state.farms[farmId].endusers[enduserId].schedule_enabled = enable;
  },

  SET_CURRENT_FARM(state, id) {
    state.currentFarmId = id;
    localStorage.setItem("currentFarmId", JSON.stringify(id));
  },

  DELETE_UNIT(state, metadata) {
    delete state.farms[metadata.farm_id].endusers[metadata.enduser_id].units[
      metadata.unit_mac
    ];
  },

  SET_UNIT_META_DATA(state, metadata) {
    const unit =
      state.farms[metadata.farm_id].endusers[metadata.enduser_id].units[
        metadata.unit_mac
      ];

    unit.name = metadata.name;
    unit.purpose = metadata.purpose;
    unit.radius = metadata.radius;
    unit.coverage = metadata.coverage;
    unit.latitude = metadata.latitude;
    unit.longitude = metadata.longitude;
  },

  SAVE_SCHEDULES(state, { farmId, schedules }) {
    state.farms[farmId].schedules = schedules;

    for (const schedule of Object.values(schedules)) {
      schedule.groups = {};
    }
  },

  SAVE_SCHEDULE(state, schedule) {
    state.farms[state.currentFarmId].schedules[schedule.id] = { ...schedule };
  },

  SAVE_SCHEDULE_GROUPS(state, { scheduleId, groups }) {
    state.farms[state.currentFarmId].schedules[scheduleId].groups = groups;

    for (const groupId of Object.keys(groups)) {
      state.farms[state.currentFarmId].schedules[scheduleId].groups[
        groupId
      ].units = [];
    }
  },

  SAVE_SCHEDULE_GROUP(state, group) {
    state.farms[state.currentFarmId].schedules[group.schedule_id].groups[
      group.id
    ] = { ...group };
  },

  SAVE_SCHEDULE_GROUP_UNITS(state, { scheduleId, groupUnits }) {
    for (const [mac, unit] of Object.entries(groupUnits)) {
      // populate the array with unit macs
      state.farms[state.currentFarmId].schedules[scheduleId].groups[
        unit.schedule_group_id
      ].units.push(mac);
    }

    // now sort the unit mac arrays per schedule group (in the order they
    // appear in the UI, and deployed schedules)
    for (const group of Object.values(
      state.farms[state.currentFarmId].schedules[scheduleId].groups
    )) {
      group.units.sort((mac1, mac2) => {
        return groupUnits[mac1].sort_index - groupUnits[mac2].sort_index;
      });
    }
  },

  DELETE_SCHEDULE_GROUP(state, group) {
    delete state.farms[state.currentFarmId].schedules[group.schedule_id].groups[
      group.id
    ];
  },

  DELETE_SCHEDULE(state, id) {
    delete state.farms[state.currentFarmId].schedules[id];
  },

  RENAME_SCHEDULE(state, { id, name }) {
    state.farms[state.currentFarmId].schedules[id].name = name;
  },

  SAVE_GROUPS(state, { farmId, groupType, groups }) {
    if (groupType === "region") {
      state.farms[farmId].regions = groups;
    } else if (groupType === "terrain") {
      state.farms[farmId].terrains = groups;
    }
  },

  SAVE_GROUP(state, group) {
    if (group.group_type === "region") {
      state.farms[state.currentFarmId].regions[group.id] = { ...group };
    } else if (group.group_type === "terrain") {
      state.farms[state.currentFarmId].terrains[group.id] = { ...group };
    }
  },

  DELETE_GROUP(state, group) {
    if (group.group_type === "region") {
      delete state.farms[group.farm_id].regions[group.id];
    } else if (group.group_type === "terrain") {
      delete state.farms[group.farm_id].terrains[group.id];
    }
  },
};
